import { DisplayCount } from '@/Atomic/Molecules/DisplayCount'
import { LoadMoreButton } from '@/Atomic/Organisms/LoadMoreButton/LoadMoreButton'

import './Sublist.Footer.scss'

interface SublistFooterProps {
  amount: number
  total: number
  labelKey: string
  onLoadMore?: () => void
}

export const SublistFooter: React.FC<SublistFooterProps> = ({
  amount,
  total,
  labelKey,
  onLoadMore,
}) => {
  const showRestrictedCountHint = !onLoadMore && amount < total

  if (!amount && !total) return null

  return (
    <div className="o-sublist-footer">
      <DisplayCount
        amount={amount}
        total={total}
        labelKey={labelKey}
        showRestrictedHint={showRestrictedCountHint}
      />
      {onLoadMore && (
        <div className="o-sublist-footer__action">
          <LoadMoreButton onClick={onLoadMore} />
        </div>
      )}
    </div>
  )
}
